@if ((alertMessage$ | async).hasError) {
<div class="alert alert-danger" role="alert">
  <div class="alert-message">
    <mat-icon>error</mat-icon>{{ 'pairing.connect.errorMessage' | translate }}
  </div>
  <button mat-icon-button aria-label="close" (click)="hideAlert()">
    <mat-icon>close</mat-icon>
  </button>
</div>
}
<form #pairingForm="ngForm" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label> {{ 'pairing.username' | translate }}</label>
    <mat-form-field appearance="outline">
      <input
        matInput
        autocomplete="username"
        id="username"
        name="username"
        [(ngModel)]="username"
        type="text"
        required
      />
      <mat-hint>
        {{
          'pairing.connect.usernameHelper' | translate: ActablProductNames
        }}</mat-hint
      >
    </mat-form-field>
  </div>

  <div class="form-group">
    <label> {{ 'login.password' | translate }}</label>
    <mat-form-field appearance="outline">
      <input
        matInput
        autocomplete="current-password"
        id="current-password"
        name="password"
        type="{{ showPassword ? 'text' : 'password' }}"
        [(ngModel)]="password"
        required
      />
      <mat-icon
        matSuffix
        class="material-icons-outlined"
        (click)="showPassword = !showPassword"
      >
        {{ showPassword ? 'visibility_off' : 'visibility' }}
      </mat-icon>
    </mat-form-field>
  </div>

  <button
    class="submit-button"
    color="primary"
    type="submit"
    mat-flat-button
    [disabled]="!token || !pairingForm.form.valid || (isLoading$ | async)"
  >
    {{ 'pairing.connect.submitButton' | translate }}
  </button>
</form>
